export default "__VITE_ASSET__7cf1db6d__"